import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { PageParameters } from '@elotech/angular-common';
import { PortalServidor } from '../../../../folha-pagamento/src/common/annotations/portal-servidor';
import { Contribuicoes } from '../../consulta-contribuicao-previdenciaria/contribuicoes.model';

@Injectable()
export class PortalServidorService {

  resource: string = '/api/portal-servidor';

  constructor(public httpClient: HttpClient) {
  }

  public getUltimosHolerites(id: any, page: PageParameters): Observable<any> {
    return this.httpClient.post({
      resource: `${this.resource}/ultimos-holerites/${id}`,
      page,
      disableSpinner: true
    });
  }

  public getProximasFeriasDoFuncionario(funcionarioId: number, disableSpinner: boolean = false) {
    return this.httpClient.get({
      disableSpinner,
      resource: `${this.resource}/proximas-ferias/${funcionarioId}`
    });
  }

  public getProximasLicencasPremioDoFuncionario(funcionarioId: number, disableSpinner: boolean = false) {
    return this.httpClient.get({
      disableSpinner,
      resource: `${this.resource}/proximas-licencas-premio/${funcionarioId}`
    });
  }

  public getProgramacaoFerias(id: number): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/programacao-ferias/${id}`,
    });
  }

  public getProgramacaoLicencaPremio(id: number): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/programacao-licenca-premio/${id}`,
    });
  }

  public loadMovimentacaoPessoal(movimentacaoPessoalId: number): Observable<any> {

    const request = {
      resource: `${this.resource}/movimentacao-pessoal/${movimentacaoPessoalId}`
    };

    return this.httpClient.get(request);
  }

  public getComprovanteRendimento(pessoaId, entidadeId, ano): Observable<any> {
    return this.httpClient.get(
      { resource: `${this.resource}/comprovante-rendimento/${pessoaId}/${ano}/${entidadeId}` }
    );
  }

  public getContribuicaoPrevidenciaria(funcionarioId, entidadeId, page): Observable<Contribuicoes> {
    return this.httpClient.get({
      resource: `${this.resource}/contribuicao-previdenciaria/${funcionarioId}/${entidadeId}`,
      page: page
    });
  }
}
